

import Logo from "../Dashboard/Logo"
import HeaderRightContent from './HeaderRightContent';
function Header({ isCollapsed, setIsCollapsed, profile }){
    return(
        <header id="page-topbar">
            <div className="navbar-header pe-1">
                <Logo isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}></Logo>
                <HeaderRightContent profile={profile}></HeaderRightContent>
            </div>
        </header>
    )
}
 
export default Header;